import React from 'react';
import { BlackCloseIcon } from '../../../../utils/svg';

export function SharedImage({ src, onClick, fileName }) {
  return (
    <div className="flex" onClick={() => onClick(src)}>
      <div>
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path
            d="M21 19V5C21 3.9 20.1 3 19 3H5C3.9 3 3 3.9 3 5v14c0 1.1 0.9 2 2 2h14c1.1 0 2-0.9 2-2zM5 5h14v6.5l-4.5-4.5-7 9-2.5-3z"
            fill="#333"
          />
        </svg>
      </div>
      <div className="text-black text-[13px] font-medium leading-[17px]">{fileName}</div>
    </div>
  );
}
